module.exports = __webpack_public_path__ + "static/img/product_images_big17_h5_zh.e0f72ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big17_h5_zh.png
// module id = COm9
// module chunks = 34